module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M22 8H2c-1.1 0-2 .9-2 2v20c0 1.1.9 2 2 2h20c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM5 10h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1zm5-10C8.9 0 8 .9 8 2v4h16a2 2 0 0 1 2 2v16h4c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2H10z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/multiple-browsers-1.js
// module id = 1292
// module chunks = 14